import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { trigger, transition, animate, style } from '@angular/animations';
import { UsersLicensPermissions } from '@account-users/account/models/LicensePermissionList';
import { License } from '@account-users/account/models/License';
import { LicenseCode } from '@account-users/account/models/LicenseCode';

@Component({
  selector: 'app-advanced-license-filter',
  templateUrl: './advanced-license-filter.component.html',
  styleUrls: ['./advanced-license-filter.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('200ms ease-in', style({ transform: 'translateX(0%)' })),
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateX(100%)' })),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdvancedLicenseFilterComponent {
  @Input() selectedPermissions: UsersLicensPermissions[] = [];
  @Input() selectedLicenses: string[] = [];
  @Input() licenses: License[];
  @Input() permissions: UsersLicensPermissions[];
  @Input() loadingFilter = false;
  @Input() showLicenseFilter = false;
  @Output() searchUsersWithLicensePermission = new EventEmitter<
    UsersLicensPermissions[]
  >();
  @Output() showHideLicensesFilter = new EventEmitter<boolean>();
  @Output() selectLicense = new EventEmitter<UsersLicensPermissions>();
  @Output() selectPermission = new EventEmitter<object>();

  showLicensesForPermission(toggledOn, license) {
    this.onShowUsersForLicensePermission(toggledOn, null, license.code);
  }

  onShowUsersForLicensePermission(
    toggleOn,
    permission: string,
    code: LicenseCode,
  ) {
    this.selectPermission.emit({
      code: code,
      permission: permission,
      toggleOn: toggleOn,
    });
  }
}
